import type { UserWorkItem } from '@/api/home/type'
import { resolveSummaryContentKind } from '@/utils/profile/content-card'

export function resolveSummaryContentColumnCount(screenWidth: number) {
  if (screenWidth <= 640) {
    return 2
  }

  if (screenWidth <= 920) {
    return 3
  }

  if (screenWidth <= 1220) {
    return 4
  }

  return 5
}

export function estimateSummaryContentHeightWeight(item: UserWorkItem) {
  const kind = resolveSummaryContentKind(item)

  if (kind === 'radio') {
    return 1.38
  }

  if (kind === 'media-imgtxt') {
    return 1.72
  }

  return 2
}

export function distributeSummaryContentItems<T extends UserWorkItem>(items: T[], count: number) {
  const columns = Array.from({ length: Math.max(1, count) }, () => [] as T[])
  const heights = Array.from({ length: columns.length }, () => 0)

  items.forEach((item) => {
    const targetIndex = heights.indexOf(Math.min(...heights))
    const nextHeight = (heights[targetIndex] ?? 0) + estimateSummaryContentHeightWeight(item)

    columns[targetIndex]?.push(item)
    heights[targetIndex] = nextHeight
  })

  return columns
}

export function distributeItemsByIndex<T>(items: T[], count: number) {
  const columns = Array.from({ length: Math.max(1, count) }, () => [] as T[])

  items.forEach((item, index) => {
    columns[index % columns.length]?.push(item)
  })

  return columns
}
